import { createFileRoute } from "@tanstack/react-router"
import { ImportResultPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/import-result/$uuid"
)({
  component: () => (
    // Managed-member imports are gated by MEMBERSHIP:READ, but bulk
    // invitation imports are reachable by users who only have
    // INVITATION:CREATE/READ (mirrors ImportsService.IMPORT_TYPE_PERMISSION
    // on the backend) — either permission unlocks this page.
    <AuthorizationGate
      anyOf={[
        { resource: Resource.MEMBERSHIP, action: Action.READ },
        { resource: Resource.INVITATION, action: Action.READ },
      ]}
    >
      <ImportResultPage />
    </AuthorizationGate>
  ),
})
